import * as i0 from '@angular/core';
import { Directive, Host, HostListener, Component, HostBinding, Input, ContentChildren, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkAccordionItem, CdkAccordionModule } from '@angular/cdk/accordion';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { takeUntil, map } from 'rxjs/operators';
import { Subject, merge } from 'rxjs';

class AiHubAccordionItemHeaderDirective {
    accordionItem;
    el;
    renderer;
    hostEl;
    constructor(accordionItem, el, renderer) {
        this.accordionItem = accordionItem;
        this.el = el;
        this.renderer = renderer;
    }
    toggleBody() {
        this.accordionItem.toggle();
        this.accordionItem.bodyState === 'expanded'
            ? this.renderer.addClass(this.hostEl, 'expanded')
            : this.renderer.removeClass(this.hostEl, 'expanded');
    }
    ngOnInit() {
        this.hostEl = this.el.nativeElement;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AiHubAccordionItemHeaderDirective, deps: [{ token: AiHubAccordionItemComponent, host: true }, { token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: AiHubAccordionItemHeaderDirective, selector: "[aihubAccordionItemHeader]", host: { listeners: { "click": "toggleBody()" } }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AiHubAccordionItemHeaderDirective, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line: directive-selector
                    selector: '[aihubAccordionItemHeader]',
                }]
        }], ctorParameters: function () { return [{ type: AiHubAccordionItemComponent, decorators: [{
                    type: Host
                }] }, { type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { toggleBody: [{
                type: HostListener,
                args: ['click']
            }] } });
/**
 *
 */
class AiHubAccordionItemBodyDirective {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AiHubAccordionItemBodyDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: AiHubAccordionItemBodyDirective, selector: "[aihubAccordionItemBody]", ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AiHubAccordionItemBodyDirective, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line: directive-selector
                    selector: '[aihubAccordionItemBody]',
                }]
        }] });
/**
 *
 */
class AiHubAccordionItemComponent extends CdkAccordionItem {
    bodyState = 'collapsed';
    hostClass = 'collapsed';
    toggle() {
        this.bodyState = this.bodyState === 'expanded' ? 'collapsed' : 'expanded';
        this.hostClass = this.bodyState;
        super.toggle();
    }
    close() {
        this.bodyState = 'collapsed';
        this.hostClass = 'collapsed';
        super.close();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AiHubAccordionItemComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AiHubAccordionItemComponent, selector: "aihub-accordion-item", host: { properties: { "class": "this.hostClass" } }, exportAs: ["accordionItem"], usesInheritance: true, ngImport: i0, template: "<div class=\"accordion-item--header\">\n    <ng-content select=\"[aihubAccordionItemHeader]\"></ng-content>\n</div>\n\n<div class=\"accordion-item--body\" [@bodyToggleState]=\"bodyState\">\n    <ng-content select=\"[aihubAccordionItemBody]\"></ng-content>\n</div>\n", styles: [":host .accordion-item--header{background:white;color:#303131}:host .accordion-item--body{overflow:hidden}\n"], animations: [
            trigger('bodyToggleState', [
                state('expanded', style({ height: '*' })),
                state('collapsed', style({ height: '0px' })),
                transition('expanded <=> collapsed', animate('.15s')),
            ])
        ] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AiHubAccordionItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aihub-accordion-item', exportAs: 'accordionItem', animations: [
                        trigger('bodyToggleState', [
                            state('expanded', style({ height: '*' })),
                            state('collapsed', style({ height: '0px' })),
                            transition('expanded <=> collapsed', animate('.15s')),
                        ])
                    ], template: "<div class=\"accordion-item--header\">\n    <ng-content select=\"[aihubAccordionItemHeader]\"></ng-content>\n</div>\n\n<div class=\"accordion-item--body\" [@bodyToggleState]=\"bodyState\">\n    <ng-content select=\"[aihubAccordionItemBody]\"></ng-content>\n</div>\n", styles: [":host .accordion-item--header{background:white;color:#303131}:host .accordion-item--body{overflow:hidden}\n"] }]
        }], propDecorators: { hostClass: [{
                type: HostBinding,
                args: ['class']
            }] } });

class AiHubAccordionComponent {
    multi = false;
    activeItem;
    accordionItems;
    /**
     * emits true if gets destroyed to ensure we unsubscribe
     */
    destroyed$;
    /**
     * emits true if ContentChildren has been changed
     */
    reload$;
    constructor() {
        this.destroyed$ = new Subject();
        this.reload$ = new Subject();
    }
    /**
     * component gets destroyed
     */
    ngOnDestroy() {
        this.destroyed$.next(true);
        this.destroyed$.complete();
        this.destroyed$ = null;
    }
    /**
     *
     */
    ngAfterContentInit() {
        if (this.multi) {
            return;
        }
        this.registerItemExpandChange();
        /**
         * register on accordion items has
         * been changed, so we add / remove items
         */
        this.accordionItems.changes
            .pipe(takeUntil(this.destroyed$))
            .subscribe(() => {
            this.reload$.next(true);
            this.registerItemExpandChange();
        });
    }
    /**
     * regiser toggle change on items
     */
    registerItemExpandChange() {
        const itemChange$ = this.accordionItems.map((item) => {
            const change$ = item.expandedChange.pipe(map((expanded) => [item, expanded]));
            return change$;
        });
        merge(...itemChange$)
            .pipe(takeUntil(merge(this.reload$, this.destroyed$)))
            .subscribe(([item, state]) => {
            if (state) {
                this.toggleActiveItem(item);
            }
            else {
                if (this.activeItem === item) {
                    this.activeItem = null;
                }
            }
        });
    }
    /**
     * toggle active item
     */
    toggleActiveItem(item) {
        if (this.activeItem) {
            this.activeItem.close();
        }
        this.activeItem = item;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AiHubAccordionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AiHubAccordionComponent, selector: "aihub-accordion", inputs: { multi: "multi" }, queries: [{ propertyName: "accordionItems", predicate: AiHubAccordionItemComponent, read: AiHubAccordionItemComponent }], ngImport: i0, template: "<div class=\"accordion\">\n    <ng-content></ng-content>\n</div>\n" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AiHubAccordionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aihub-accordion', template: "<div class=\"accordion\">\n    <ng-content></ng-content>\n</div>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { multi: [{
                type: Input
            }], accordionItems: [{
                type: ContentChildren,
                args: [AiHubAccordionItemComponent, { read: AiHubAccordionItemComponent }]
            }] } });

class AihubAccordionModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AihubAccordionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: AihubAccordionModule, declarations: [AiHubAccordionComponent,
            AiHubAccordionItemComponent,
            AiHubAccordionItemBodyDirective,
            AiHubAccordionItemHeaderDirective], imports: [CommonModule,
            CdkAccordionModule], exports: [AiHubAccordionComponent,
            AiHubAccordionItemComponent,
            AiHubAccordionItemBodyDirective,
            AiHubAccordionItemHeaderDirective] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AihubAccordionModule, imports: [CommonModule,
            CdkAccordionModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AihubAccordionModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        AiHubAccordionComponent,
                        AiHubAccordionItemComponent,
                        AiHubAccordionItemBodyDirective,
                        AiHubAccordionItemHeaderDirective,
                    ],
                    imports: [
                        CommonModule,
                        CdkAccordionModule
                    ],
                    exports: [
                        AiHubAccordionComponent,
                        AiHubAccordionItemComponent,
                        AiHubAccordionItemBodyDirective,
                        AiHubAccordionItemHeaderDirective,
                    ],
                    providers: [],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AiHubAccordionComponent, AiHubAccordionItemBodyDirective, AiHubAccordionItemComponent, AiHubAccordionItemHeaderDirective, AihubAccordionModule };
